module.exports = function getBreakpoint() {
    return window.getComputedStyle(document.documentElement).getPropertyValue('--breakpoint');
};